import { Skeleton } from '../ui/skeleton';

const LeaderboardCardSkeleton = () => {
    return (
        <div className="animate-pulse">
            {[...Array(5)].map((_, i) => (
                <div
                    key={i}
                    className="flex justify-between items-center p-4 border-b border-neutral-300"
                >
                    <span className="font-semibold flex gap-6 justify-center items-center">
                        <Skeleton className="h-4 w-4" />
                        <Skeleton className="h-4 w-25" />
                    </span>
                    {/* <Skeleton className="h-4 w-[50px]" /> */}
                </div>
            ))}
        </div>
    );
};

export default LeaderboardCardSkeleton;
